import { parseConsentCallEndedNotice } from '@shared/calls/recording-consent'
import {
  dismissMyConsentCallEndedNotice,
  fetchMyConsentCallEndedNotice,
} from './appsync-client'
import {
  closeConsentCallEndedNotice,
  showConsentCallEndedNotice,
} from '../stores/consent-call-ended-store'

/**
 * Show a consent-ended popup the app missed live: the server keeps the notice
 * on the account until it is dismissed. Best-effort — never throws.
 */
export async function refreshConsentCallEndedNotice(): Promise<void> {
  try {
    const notice = parseConsentCallEndedNotice(await fetchMyConsentCallEndedNotice())
    if (notice) showConsentCallEndedNotice(notice)
  } catch {
    /* older backend without the field, or offline — retried on next foreground */
  }
}

/** Close the popup and clear the account's pending notice for that call. */
export async function dismissConsentCallEndedNotice(): Promise<void> {
  const callId = closeConsentCallEndedNotice()
  if (!callId) return
  try {
    await dismissMyConsentCallEndedNotice(callId)
  } catch (err) {
    console.warn('[consent-call-ended] server dismiss failed', err)
  }
}
